<div class="mobilne-ponude-container">
  <!-- Filters Section -->
  <div class="filters-section">
    <div class="filter-row">
      <!-- Country Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Država</label>
        <dx-select-box [dataSource]="countries" displayExpr="name" valueExpr="code" placeholder="Odaberite državu..."
          [(value)]="selectedCountry" [searchEnabled]="true" class="filter-control">
        </dx-select-box>
      </div>

      <!-- Date Range Picker -->
      <div class="filter-group">
        <label class="filter-label">Raspon datuma</label>
        <dx-date-range-box displayFormat="dd.MM.yyyy" [startDate]="startDate" [endDate]="endDate" (startDateChange)="onStartDateChange($event)"
          (endDateChange)="onEndDateChange($event)" placeholder="Odaberite raspon datuma..." class="filter-control">
        </dx-date-range-box>
      </div>

      <!-- Execute Button -->
      <div class="filter-group">
        <label class="filter-label">&nbsp;</label>
        <dx-button text="Učitaj podatke" icon="search" type="default" stylingMode="contained" (onClick)="loadData()"
          [disabled]="!isFormValid()" class="execute-btn">
        </dx-button>
      </div>

      <!-- Create SMS Potražnja Button -->
      <div class="filter-group">
        <label class="filter-label">&nbsp;</label>
        <dx-button [visible]="isUserModerator" text="Kreiraj potražnju" icon="plus" type="default" stylingMode="contained"
          (onClick)="showCreateMobilnaPotraznja()" class="execute-btn">
        </dx-button>
      </div>
    </div>
  </div>

  <!-- Data Grid Section -->
  <div class="grid-section">
    <dx-data-grid #mobilnaPotraznjeGrid id="mobilnaPotraznjeGrid" keyExpr="id" [dataSource]="gridData" [showBorders]="true"
      [allowColumnResizing]="true" [showColumnLines]="true" [showRowLines]="true" [hoverStateEnabled]="true"
      [filterRow]="{ visible: true }" [searchPanel]="{ visible: true }" [paging]="{ pageSize: 50 }" [pager]="{
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      }" [selection]="{ mode: 'single' }" [rowAlternationEnabled]="true">

      <!-- Columns Definition -->
      <dxi-column type="buttons" width="120" caption="Opcije" [visible]="isUserModerator">
        <dxi-button name="delete" icon="trash" hint="Izbriši" [visible]="true" [onClick]="onDeleteClick"></dxi-button>
      </dxi-column>

      <dxi-column dataField="firma.naziv" caption="Firma"></dxi-column>
      <dxi-column dataField="tekst" caption="Tekst" [width]="300"></dxi-column>
      <dxi-column dataField="datum" caption="Datum" dataType="date" format="dd.MM.yyyy"></dxi-column>

      <!-- Master Detail -->
      <!-- <dxo-master-detail [enabled]="true" template="detailTemplate">
      </dxo-master-detail>

      <div *dxTemplate="let data of 'detailTemplate'" class="master-detail">
        <div class="detail-section">
          <h4>Detalji mobilne ponude: {{ data.data.firma?.naziv || 'N/A' }}</h4>
          <p><strong>Firma:</strong> {{ data.data.firma?.naziv || 'N/A' }}</p>
          <p><strong>Kontakt osoba:</strong> {{ data.data.firma?.kontakt1 || 'N/A' }}</p>
          <p><strong>Telefon:</strong> {{ data.data.firma?.telefon1 || 'N/A' }}</p>
          <p><strong>Grad:</strong> {{ data.data.firma?.grad1?.grad1 || 'N/A' }}</p>
          <p><strong>Tekst ponude:</strong> {{ data.data.tekst || 'N/A' }}</p>
        </div>
      </div> -->
    </dx-data-grid>
  </div>

  <!-- Create SMS Potražnja Popup -->
  <app-create-mobilna-potraznja 
    [visible]="createMobilnaPotraznjaPopupVisible" 
    (visibleChange)="createMobilnaPotraznjaPopupVisible = $event"
    (mobilnaPotraznjaCreated)="onMobilnaPotraznjaCreated($event)">
  </app-create-mobilna-potraznja>
  <!-- Loading Overlay -->
  <dx-load-panel [position]="loadPanelPosition" [visible]="loading" [showIndicator]="true" [showPane]="true"
    [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>
</div>